import { recordLinkV2 } from 'utilities/tagging'
import { CAN_CANCEL_ACCOUNT, CAN_NOT_LOAD_CANCEL_ACCOUNT } from 'constants/tagging'
import { MODAL_VALIDATION_TAGGINGS } from '../constants/tagging'

const getEventValues = (immAccountValidation, isRetry) => {
    const hasError = immAccountValidation.get('isError')
    const isSuccess = immAccountValidation.get('isSuccess')

    const { descriptionText } = immAccountValidation.get('validationMessage').toJS()

    const validationAccountData = MODAL_VALIDATION_TAGGINGS[descriptionText] ?? null

    if (validationAccountData) {
        return {
            ...validationAccountData,
            categoriaEvento: window.utag_data.nombrePagina,
        }
    }

    if (hasError) {
        return {
            categoriaEvento: window.utag_data.nombrePagina,
            accionEvento: CAN_NOT_LOAD_CANCEL_ACCOUNT,
            component: `modal/${CAN_NOT_LOAD_CANCEL_ACCOUNT}`,
        }
    }

    if (isSuccess) {
        return {
            categoriaEvento: window.utag_data.nombrePagina,
            accionEvento: CAN_CANCEL_ACCOUNT,
            component: `modal/${CAN_CANCEL_ACCOUNT}`
        }
    }
}

export const taggingOpenEvent = (immAccountValidation) => {
    const eventValues = getEventValues(immAccountValidation)
    recordLinkV2({
        ...eventValues,
        etiquetaEvento: 'open',
        action: "open",
        format: "modal",
        element: "full"
    })
}

export const taggingCloseEvent = (immAccountValidation) => {
    const eventValues = getEventValues(immAccountValidation)
    recordLinkV2({
        etiquetaEvento: 'close',
        ...eventValues,
        action: "close",
        format: "cross",
        element: "close"
    })
}

export const taggingCancelEvent = (immAccountValidation) => {
    const eventValues = getEventValues(immAccountValidation)
    recordLinkV2({
        etiquetaEvento: 'cancel',
        ...eventValues,
        action: "cancel",
        format: "link",
        element: "cancel"
    })
}

export const taggingUnderstoodEvent = (immAccountValidation) => {
    const eventValues = getEventValues(immAccountValidation)
    recordLinkV2({
        etiquetaEvento: 'understood',
        ...eventValues,
        action: "click",
        format: "button",
        element: "understood"
    })
}

export const taggingRedirectToTransferEvent = (immAccountValidation) => {
    const eventValues = getEventValues(immAccountValidation)
    recordLinkV2({
        etiquetaEvento: 'makeATransfer',
        ...eventValues,
        action: "click",
        format: "button",
        element: "makeATransfer"
    })
}

export const taggingRedirectToFiocEvent = (immAccountValidation) => {
    const eventValues = getEventValues(immAccountValidation)
    recordLinkV2({
        etiquetaEvento: 'updateData',
        ...eventValues,
        action: "click",
        format: "button",
        element: "updateData"
    })
}

export const taggingRedirectToIDEvent = (immAccountValidation) => {
    const eventValues = getEventValues(immAccountValidation)
    recordLinkV2({
        etiquetaEvento: 'updateDocument',
        ...eventValues,
        action: "click",
        format: "button",
        element: "updateDocument"
    })
}

export const taggingReTryEvent = (immAccountValidation) => {
    const eventValues = getEventValues(immAccountValidation)

    recordLinkV2({
        etiquetaEvento: 'tryAgain',
        ...eventValues,
        action: "click",
        format: "button",
        element: "tryAgain"
    })
}
